import { all } from 'redux-saga/effects';

import { sagas as appSagas } from 'store/app/sagas';

export default function* rootSaga() {
  yield all([
    ...appSagas
  ]);
}
